webpackJsonp([114276838955818,60335399758886],{

/***/ 112:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(233);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(112);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.3854ebec.svg";

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScreensizeProvider = function (_Component) {
	  _inherits(ScreensizeProvider, _Component);
	
	  function ScreensizeProvider() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScreensizeProvider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      screensize: _this.getScreensize()
	    }, _this.handleResize = function (e) {
	      var nextScreensize = _this.getScreensize();
	      if (nextScreensize !== _this.state.screensize) {
	        _this.setState({ screensize: nextScreensize });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScreensizeProvider.prototype.getChildContext = function getChildContext() {
	    return {
	      screensize: this.state.screensize
	    };
	  };
	
	  ScreensizeProvider.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ screensize: this.getScreensize() });
	    window.addEventListener("resize", this.handleResize);
	  };
	
	  ScreensizeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.handleResize);
	  };
	
	  ScreensizeProvider.prototype.getScreensize = function getScreensize() {
	    if (typeof window !== "undefined") {
	      if (window.innerWidth <= 480) return "phone";
	      if (window.innerWidth <= 615) return "l-phone";
	      if (window.innerWidth <= 768) return "tablet";
	      if (window.innerWidth <= 980) return "small";
	    }
	    return "desktop";
	  };
	
	  ScreensizeProvider.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return ScreensizeProvider;
	}(_react.Component);
	
	ScreensizeProvider.displayName = "ScreensizeProvider";
	ScreensizeProvider.childContextTypes = {
	  screensize: _propTypes2.default.string.isRequired
	};
	exports.default = ScreensizeProvider;
	module.exports = exports["default"];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(71);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _MailchimpForm = __webpack_require__(231);
	
	var _MailchimpForm2 = _interopRequireDefault(_MailchimpForm);
	
	var _colors = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterContainer = /*#__PURE__*/_styledComponents2.default.footer.withConfig({
	  displayName: "Footer__FooterContainer"
	})(["position:relative;padding:50px 0;color:white;border-top:2px solid white;background-color:", ";"], _colors.PRIMARY_TEXT);
	
	var FooterWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterWrapper"
	})(["max-width:1000px;margin:0 auto;width:100%;display:flex;justify-content:space-between;h4{color:rgba(255,255,255,1);margin-bottom:15px;}p{color:rgba(255,255,255,0.8);}a{color:white;border-bottom:1px solid rgba(255,255,255,0.5);}@media (max-width:768px){width:90%;flex-direction:column;padding-bottom:100px;}@media (max-width:615px){width:100%;flex-direction:column;padding-bottom:100px;}"]);
	
	var FooterInfo = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterInfo"
	})(["width:360px;padding:20px;max-width:100%;"]);
	
	var FooterForm = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterForm"
	})(["width:520px;padding:20px;max-width:100%;"]);
	
	var FooterSocial = /*#__PURE__*/_styledComponents2.default.ul.withConfig({
	  displayName: "Footer__FooterSocial"
	})(["list-style-type:none;padding:0;a{color:", ";margin-right:20px;font-size:24px;border:none;}"], _colors.SMALLCHAT_PURPLE);
	
	var FooterLinks = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterLinks"
	})(["@media (max-width:768px){position:absolute;bottom:80px;}"]);
	
	var FooterCopyright = /*#__PURE__*/_styledComponents2.default.p.withConfig({
	  displayName: "Footer__FooterCopyright"
	})(["margin-top:100px;a{color:white;}@media (max-width:768px){position:absolute;bottom:50px;}"]);
	
	var Footer = function Footer(props) {
	  return _react2.default.createElement(
	    FooterContainer,
	    null,
	    _react2.default.createElement(
	      FooterWrapper,
	      null,
	      _react2.default.createElement(
	        FooterInfo,
	        null,
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Any questions? Let's chat!"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Chat with us using the widget at the bottom-right of the page, or shoot us an email at",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:support@small.chat" },
	            "support@small.chat"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          FooterSocial,
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "https://twitter.com/smallchatapp" },
	              _react2.default.createElement("i", { className: "fa fa-twitter", "aria-hidden": "true" })
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "https://stories.nicer.io/" },
	              _react2.default.createElement("i", { className: "fa fa-medium", "aria-hidden": "true" })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          FooterLinks,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/terms" },
	            "Terms of Use"
	          ),
	          " ",
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/terms#privacy" },
	            "Privacy Policy"
	          ),
	          " ",
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/terms#gdpr" },
	            "GDPR"
	          )
	        ),
	        _react2.default.createElement(
	          FooterCopyright,
	          null,
	          "\xA9 ",
	          _react2.default.createElement(
	            "a",
	            { href: "http://nicer.io/" },
	            "Nicer LLC"
	          ),
	          ",",
	          " ",
	          new Date().getFullYear()
	        )
	      ),
	      _react2.default.createElement(
	        FooterForm,
	        null,
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Sign up for updates!"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "We'll send out emails when we add new features",
	          _react2.default.createElement("br", null),
	          "or schedule maintenance."
	        ),
	        _react2.default.createElement(_MailchimpForm2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var embedHtml = "\n  <div id=\"mc_embed_signup\">\n    <form action=\"http://nicer.us14.list-manage.com/subscribe/post?u=018134740cf42b7d8889b8b3b&amp;id=a710d9caa9\" method=\"post\" id=\"mc-embedded-subscribe-form\" name=\"mc-embedded-subscribe-form\" class=\"validate\" target=\"_blank\" novalidate>\n      <div id=\"mc_embed_signup_scroll\">\n        <div class=\"mc-row-one\">\n          <div class=\"mc-field-group mc-name\">\n            <label for=\"mce-NAME\">Name</label>\n            <input type=\"text\" value=\"\" name=\"NAME\" class=\"required\" id=\"mce-NAME\">\n          </div>\n          <div class=\"mc-field-group mc-company\">\n            <label for=\"mce-COMPANY\">Company</label>\n            <input type=\"text\" value=\"\" name=\"COMPANY\" class=\"required\" id=\"mce-COMPANY\">\n          </div>\n        </div>\n        <div class=\"mc-row-two\">\n          <div class=\"mc-field-group\">\n            <label for=\"mce-EMAIL\">Email</label>\n            <input type=\"email\" value=\"\" name=\"EMAIL\" class=\"required email\" id=\"mce-EMAIL\">\n          </div>\n            <div id=\"mce-responses\" class=\"clear\">\n              <div class=\"response\" id=\"mce-error-response\" style=\"display:none\"></div>\n              <div class=\"response\" id=\"mce-success-response\" style=\"display:none\"></div>\n          </div>\n        </div>\n        <div style=\"position: absolute; left: -5000px;\" aria-hidden=\"true\">\n          <input type=\"text\" name=\"b_018134740cf42b7d8889b8b3b_fffff31933\" tabindex=\"-1\" value=\"\">\n        </div>\n        <div class=\"clear\">\n          <input type=\"submit\" value=\"Sign Up\" name=\"subscribe\" id=\"mc-embedded-subscribe\" class=\"button\">\n        </div>\n      </div>\n    </form>\n  </div>\n";
	
	var MailchimpStyler = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "MailchimpForm__MailchimpStyler"
	})(["margin:20px 0;.mc-row-one{display:flex;}.mc-field-group{display:flex;flex-direction:column;label{font-size:12px;font-weight:600;}input{border:none;outline:none;font-size:16px;height:36px;line-height:36px;border-radius:8px;padding:0 8px;margin:10px 0 15px;}}.mc-name{width:40%;padding-right:20px;}.mc-company{width:60%;}.button{margin-top:15px;display:block;width:120px;height:36px;border:none;outline:none;font-size:16px;margin-left:auto;line-height:36px;font-weight:900;border-radius:8px;background-color:white;-webkit-appearance:none;box-shadow:3px 3px 0 0 ", ";transition:box-shadow 200ms;&:hover{box-shadow:5px 5px 0 0 ", ";}}"], _colors.SMALLCHAT_PURPLE, _colors.SMALLCHAT_PURPLE);
	
	var MailchimpForm = function (_PureComponent) {
	  _inherits(MailchimpForm, _PureComponent);
	
	  function MailchimpForm() {
	    _classCallCheck(this, MailchimpForm);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  MailchimpForm.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false;
	  };
	
	  MailchimpForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      MailchimpStyler,
	      null,
	      _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: embedHtml } })
	    );
	  };
	
	  return MailchimpForm;
	}(_react.PureComponent);
	
	exports.default = MailchimpForm;
	module.exports = exports["default"];

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(71);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(492);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = /*#__PURE__*/_styledComponents2.default.nav.withConfig({
	  displayName: "Nav__Container"
	})(["z-index:9001;position:fixed;top:0;left:0;right:0;width:100%;background-color:white;@media (max-width:480px){position:absolute;}"]);
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "Nav__Wrapper"
	})(["width:100%;margin:0 auto;padding:0 20px;max-width:1200px;display:flex;align-items:center;justify-content:space-between;"]);
	
	var Brand = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "Nav__Brand"
	})([""]);
	
	var Logo = /*#__PURE__*/_styledComponents2.default.img.withConfig({
	  displayName: "Nav__Logo"
	})(["margin-top:4px;height:32px;@media (max-width:768px){margin-top:10px;height:24px;}"]);
	
	var PagesList = /*#__PURE__*/_styledComponents2.default.ul.withConfig({
	  displayName: "Nav__PagesList"
	})(["margin:0;padding:0;display:flex;align-items:baseline;list-style-type:none;li{display:flex;align-items:center;height:60px;margin-left:30px;.PageLink{display:block;line-height:24px;border-bottom:2px solid transparent;}.PageLink:hover,.PageLink-active{color:", ";border-bottom-color:", ";}}@media (max-width:768px){overflow:hidden;position:absolute;top:100%;left:0;right:0;flex-direction:column;background-color:white;height:", "px;transition:height ", "ms ease-out;li{height:50px margin-left:20px;}}"], _colors.PRIMARY_TEXT, _colors.PRIMARY_TEXT, function (props) {
	  return props.expand ? 50 * 4 : 0;
	}, function (props) {
	  return props.expand ? 100 : 0;
	});
	
	var Button = /*#__PURE__*/_styledComponents2.default.a.withConfig({
	  displayName: "Nav__Button"
	})(["display:block;padding:5px 20px;background-color:white;border-radius:10px;box-shadow:0 5px 10px 0 rgba(0,0,0,0.1);transition:all 150ms;cursor:pointer;&:hover{transform:translateY(-1px);box-shadow:0 10px 20px 0 rgba(0,0,0,0.1);}"]);
	
	var MenuButton = /*#__PURE__*/(0, _styledComponents2.default)(Button).withConfig({
	  displayName: "Nav__MenuButton"
	})(["@media (min-width:769px){display:none;}"]);
	
	function PageLink(props) {
	  return _react2.default.createElement(_gatsbyLink2.default, _extends({}, props, { className: "PageLink", activeClassName: "PageLink-active" }));
	}
	
	var Nav = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Nav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      expand: false
	    }, _this.toggleMenu = function () {
	      _this.setState({ expand: !_this.state.expand });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Nav.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.location.pathname !== this.props.location.pathname) {
	      this.setState({ expand: false });
	    }
	  };
	
	  Nav.prototype.render = function render() {
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Brand,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            _react2.default.createElement(Logo, { src: _logo2.default })
	          )
	        ),
	        _react2.default.createElement(
	          PagesList,
	          { expand: this.state.expand },
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              PageLink,
	              { to: "/pricing" },
	              "Pricing"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              PageLink,
	              { to: "/features" },
	              "Features"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { className: "PageLink", href: "https://docs.small.chat/" },
	              "Docs"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              Button,
	              { href: "https://my.small.chat/" },
	              "Login"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          MenuButton,
	          { onClick: this.toggleMenu },
	          "Menu"
	        )
	      )
	    );
	  };
	
	  return Nav;
	}(_react.Component);
	
	exports.default = Nav;
	module.exports = exports["default"];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Layout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ScreensizeProvider = __webpack_require__(87);
	
	var _ScreensizeProvider2 = _interopRequireDefault(_ScreensizeProvider);
	
	var _Footer = __webpack_require__(230);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Nav = __webpack_require__(232);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: "layouts__Container"
	})(["margin:0 auto;width:100%;padding-top:100px;@media (max-width:768px){padding-top:50px;}"]);
	
	function Layout(_ref) {
	  var children = _ref.children,
	      location = _ref.location;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(_Nav2.default, { location: location }),
	      _react2.default.createElement(
	        _ScreensizeProvider2.default,
	        null,
	        children()
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    )
	  );
	}
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-9de4978a27380b4167e7.js